module.exports = __webpack_public_path__ + "static/media/groceries-housekeeping.f7721ec0.svg";